import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
export default {
  __name: 'SkeletonRenderer',
  props: {
    spec: {
      type: Array,
      required: true
    },
    containerClass: {
      type: String,
      default: 'space-y-4 pa-4'
    }
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(__props.containerClass)
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.spec, (item, index) => {
        return _openBlock(), _createElementBlock(_Fragment, {
          key: index
        }, [item.type === 'row' ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(['flex', item.spacing || 'space-x-4', item.class])
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.columns, (col, colIndex) => {
          return _openBlock(), _createBlock(_component_v_skeleton_loader, {
            key: colIndex,
            type: col.type,
            class: _normalizeClass(col.class),
            style: _normalizeStyle(col.style)
          }, null, 8, ["type", "class", "style"]);
        }), 128))], 2)) : (_openBlock(), _createBlock(_component_v_skeleton_loader, {
          key: 1,
          type: item.type,
          class: _normalizeClass(item.class),
          style: _normalizeStyle(item.style)
        }, null, 8, ["type", "class", "style"]))], 64);
      }), 128))], 2);
    };
  }
};